import { Typography } from "@mui/material";

export default function PageTitle({ children, ...otherProps }) {
  return (
    <Typography variant="h3" mt={3} {...otherProps}>
      {children}
    </Typography>
  );
}
